/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";
import { Box } from "@mui/material";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type PowerOfAttorneySignatoryHighlightBoxProps = {
  product: AbstractCase;
};

export default function PowerOfAttorneySignatoryHighlightBox({ product }: PowerOfAttorneySignatoryHighlightBoxProps) {
  if (product.clientIsCustomer) {
    return null;
  }

  return (
    <Box sx={{ marginTop: "1rem" }}>
      <HighlightBox textColor={"defaultText"} headline={""}>
        {product.clientWasMinorAtContractDate &&
          (product.clientLegalRepresentativeAmount !== 2 ||
            (product.clientLegalRepresentativeAmount === 2 && product.clientLegalRepresentativesAuthorizationType === "individually")) &&
          `Achtung: Hier muss der gesetzliche Vertreter unterschreiben. In Ihrem Fall also: ${
            product.clientLegalRepresentative.gender === "male" ? "Herr" : "Frau"
          } ${product.clientLegalRepresentative.givenName} ${product.clientLegalRepresentative.familyName}`}
        {product.clientWasMinorAtContractDate &&
          product.clientLegalRepresentativeAmount === 2 &&
          product.clientLegalRepresentativesAuthorizationType === "both" &&
          `Achtung: Hier müssen beide gesetzlichen Vertreter unterschreiben. In Ihrem Fall also:
                  ${product.clientLegalRepresentative.gender === "male" ? "Herr" : "Frau"} ${product.clientLegalRepresentative.givenName} ${
            product.clientLegalRepresentative.familyName
          } und
                  ${product.secondClientLegalRepresentative.gender === "male" ? "Herr" : "Frau"} ${product.secondClientLegalRepresentative.givenName} ${
            product.secondClientLegalRepresentative.familyName
          }`}
        {!product.clientWasMinorAtContractDate &&
          `Achtung: Hier muss die Person unterschreiben, die den Vertrag geschlossen hat. In Ihrem Fall also: ${
            product.client.gender === "male" ? "Herr" : "Frau"
          } ${product.client.givenName} ${product.client.familyName}`}
      </HighlightBox>
    </Box>
  );
}
